import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {
    transform(value: string, decimals): string {
        if (!value || value === null) { value =  '0'; }

        // console.log("v: ", value);


        if (!decimals && decimals !== 0) {
            decimals = 2;
        }

        // return Number(value).toLocaleString(undefined, { maximumFractionDigits: decimals });

        // console.log("r:  " + Number(value).toFixed(decimals));
        return Number(value).toFixed(decimals);

    }
}
